import { format, parseISO } from 'date-fns';
import { OFFER_COLOR_PALETTE, STATUS_CONFIG } from './constants';

// Couleur stable pour chaque offre (hash simple)
export const getColorFromId = (id) => {
  let hash = 0;
  const str = String(id);

  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }

  return OFFER_COLOR_PALETTE[Math.abs(hash) % OFFER_COLOR_PALETTE.length];
};

export const getStatus = (key) => STATUS_CONFIG[key] || STATUS_CONFIG.default;

export const formatClientName = (client, isIntervenant) => {
  if (!client) return '—';
  if (typeof client === 'string') return client;

  return isIntervenant
    ? `${client?.prenom_client || ''}`.trim()
    : `${client?.prenom_client || ''} ${client?.nom_client || ''}`.trim();
};

// ----- Mapping des réponses API -----
export const mapOffre = (item) => ({
  id: item.id_offre,
  nom: item.info_offre?.titre_offre || 'Sans titre',
  intervenant: item.intervenant
    ? `${item.intervenant.prenom_user} ${item.intervenant.nom_user}`
    : null,
  intervenantId: item.intervenant?.id_user || null,
  color: getColorFromId(item.id_offre),
});

export const mapReservation = (res) => {
  const start = parseISO(res.start_time_reservation);
  const end = parseISO(res.end_time_reservation);

  return {
    id: res.id_offre_reservation,
    offreId: Number(res.id_offre),
    dateKey: format(start, 'yyyy-MM-dd'),
    rawStart: res.start_time_reservation,
    rawEnd: res.end_time_reservation,
    heureDebut: format(start, 'HH:mm'),
    heureFin: format(end, 'HH:mm'),
    client: res.client || null,
    intervenant: res.user
      ? `${res.user.prenom_user} ${res.user.nom_user}`
      : 'Non assigné',
    status: res.status_reservation,
    comptes_rendus: res.comptes_rendus || null, // 👈 Ajoutez cette ligne ici
    originalData: res,
    
  };
};
